import { Injectable } from '@angular/core';

@Injectable()
export class ImageManipulationService {
  currentConfigs = new Map();

  getConfigForImage(imageId: number) {
    if (!this.currentConfigs.has(imageId)) {
      return null;
    }
    const cfg = this.currentConfigs.get(imageId);
    cfg.changedFilters = true;
    return cfg;
  }

  saveConfig(imageId: number, config: any) {
    config.changedFilters = true;
    this.currentConfigs.set(imageId, config);
  }
}
